var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInventoryItemQuantity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00001 13.4793C6.52918 13.4793 4.52084 11.471 4.52084 9.00016C4.52084 6.52933 6.52918 4.521 9.00001 4.521C11.4708 4.521 13.4792 6.52933 13.4792 9.00016C13.4792 11.471 11.4708 13.4793 9.00001 13.4793ZM9.00001 5.146C6.87501 5.146 5.14584 6.87516 5.14584 9.00016C5.14584 11.1252 6.87501 12.8543 9.00001 12.8543C11.125 12.8543 12.8542 11.1252 12.8542 9.00016C12.8542 6.87516 11.125 5.146 9.00001 5.146Z",
    fill: "#E60A2B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5458 10.6377C10.4917 10.6377 10.4375 10.6252 10.3875 10.5919L9.09584 9.82106C8.77501 9.62939 8.53751 9.20856 8.53751 8.83773V7.12939C8.53751 6.95856 8.67917 6.81689 8.85001 6.81689C9.02084 6.81689 9.16251 6.95856 9.16251 7.12939V8.83773C9.16251 8.98773 9.28751 9.20856 9.41667 9.28356L10.7083 10.0544C10.8583 10.1419 10.9042 10.3336 10.8167 10.4836C10.7542 10.5836 10.65 10.6377 10.5458 10.6377Z",
    fill: "#E60A2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryItemQuantity);
export default __webpack_public_path__ + "static/media/inventory-item-quantity.18a4f76293614c9228ebf38c0261cbe3.svg";
export { ForwardRef as ReactComponent };